import styles from "./Courier.module.scss";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import SelectComponent from "../../../components/shared/select/SelectComponent";
import InputComponent from "../../../components/shared/input/InputComponent";
import OrderRow from "../../../components/pages/courier/OrderRow";
import MainButton from "../../../components/shared/button/MainButton";
import PackagesModal from "../../../components/pages/admin-panels/courier/PackagesModal";
import { CourierServices } from "../../../services/courier.service";
import { BankCardsServices } from "../../../services/bankCards.service";
import { AxiosResponse } from "axios";
import Spinner from "../../../components/shared/spinner/Spinner";
import checked from "../../../assets/images/pages/login/checkboxMessage.svg";
import {
  ApiPaginationResponse,
  BankCardType,
  DeliveryPriceResponse,
  OrderData,
  OrderPackagesDataType,
  PaymentDataType,
  RegionDataType,
} from "../../../interface/site.interface";
import CustomCheckbox from "../../../components/shared/checkBox/CheckBox";
import Card from "../../../components/pages/card/Card";
import PaginationControls from "../../../components/shared/pagination/PaginationControls";
import { toast } from "react-toastify";
import ArrowImage from "../../../assets/images/pages/login/CaretLeft.svg";
import CalendarImg from "../../../assets/images/packages/CalendarDots.svg";
import MapComponent from "../../../components/shared/MapCompanent/MapCompanent";
import PhoneInputComponent from "../../../components/shared/input-phone-component/PhoneInputComponent";
import { useSite } from "../../../context/TranslationContext";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";
import { ApiResponse } from "../../../interface/response";
import CardSelectModal from "../../../components/shared/card-select-modal/CardSelectModal";
import PaymentStatusModal from "../../../components/shared/payment-status-modal/PaymentStatusModal";
import PaymentMethodModal from "../../../components/shared/payment-method-modal/PaymentMethodModal";
import NoCardsModal from "../../../components/shared/no-cards-modal/NoCardsModal";
import { useServiceDebt } from "../../../hooks/useServiceDebt";
import ServiceDebtOverlay from "../../../components/shared/service-debt-overlay/ServiceDebtOverlay";

const Courier: React.FC = () => {
  const { serviceDebt, orderDebt } = useServiceDebt();
  const [formValues, setFormValues] = useState({
    phone: "",
    payment_type_id: "",
    address: "",
    date: "",
    area_id: "",
    urgent_order: false,
  });
  // const {  loading: siteLoading } = useSite();
  const { data } = useSelector((state: RootState) => state.translationData);

  const [region, setRegion] = useState<RegionDataType[]>([]);
  const [packages, setPackages] = useState<OrderPackagesDataType[]>([]);
  const [payment_type, setPaymentType] = useState<PaymentDataType[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedPackages, setSelectedPackages] = useState<number[]>([]);
  const [allOrders, setAllOrders] = useState<OrderData[]>([]);
  const [addressCoordinates, setAddressCoordinates] = useState<{
    lat: number;
    lon: number;
  } | null>(null);
  const [phoneCode, setPhoneCode] = useState("50");
  const dispatch = useDispatch<AppDispatch>();

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [minDate, setMinDate] = useState<string>("");
  const [maxDate, setMaxDate] = useState<string>("");
  const [orderHistoryLoading, setOrderHistoryLoading] = useState(true);
  const [showAllPackages, setShowAllPackages] = useState(false);
  const [responseCalculate, setResponseCalculate] =
    useState<DeliveryPriceResponse | null>(null);
  const [paginationData, setPaginationData] =
    useState<ApiPaginationResponse<OrderData> | null>(null);
  const [selectedPackageObjects, setSelectedPackageObjects] = useState<
    OrderPackagesDataType[]
  >([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cards, setCards] = useState<BankCardType[]>([]);
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isPaymentStatusOpen, setIsPaymentStatusOpen] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isCardPaymentLoading, setIsCardPaymentLoading] = useState(false);
  const [pendingPayload, setPendingPayload] = useState<any>(null);
  const [isPaymentMethodModalOpen, setIsPaymentMethodModalOpen] = useState(false);
  const [paymentErrorMessage, setPaymentErrorMessage] = useState("");
  const [isNoCardsModalOpen, setIsNoCardsModalOpen] = useState(false);
  const language = useSelector((state: RootState) => state.language.language);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      await CourierServices.getAllRegions().then((res) => setRegion(res?.data));
      await CourierServices.getAllPackages().then((res) => {
        setPackages(res?.data.original);
      });
      await CourierServices.getPaymentType().then((res) => {});
      await CourierServices.getAllOrders().then((res) => {
        setAllOrders(res.data.original.data);
        setPaginationData(res?.data.original);
        setOrderHistoryLoading(false);
      });
    };

    fetchData();
  }, [language]);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    CourierServices.get_courierSetting().then((res) => {
      const setting = res.data.original;
      if (setting) {
        const parseDate = (dateStr: any) => {
          const [year, month, day] = dateStr.split("T")[0].split("-");
          return `${year}-${month}-${day}`;
        };

        const min = parseDate(setting.min_date);
        const max = parseDate(setting.max_date);
        setMinDate(min);
        setMaxDate(max);

        if (
          formValues.date &&
          (formValues.date < min || formValues.date > max)
        ) {
          setFormValues((prev) => ({ ...prev, date: "" }));
        }
      }
    });
  }, []);
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value, type, checked } = e.target as HTMLInputElement;

    if (type === "radio" || type === "checkbox") {
      if (name === "urgent_order") {
        const newUrgentOrder = checked;
        setFormValues((prev) => {
          const updatedValues = {
            ...prev,
            [name]: newUrgentOrder,
          };
          return updatedValues;
        });
      }
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[name];
      return newErrors;
    });
  };
  const handlePostOnChange = async () => {
    if (!formValues?.area_id) return;

    const payload = {
      area_id: formValues.area_id,
      packages: selectedPackages,
      urgent: formValues.urgent_order,
    };

    try {
      const response =
        await CourierServices.Post_calculatedelivery_courier(payload);
      setResponseCalculate(response.data.original);
    } catch (error) {}
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationErrors: { [key: string]: string } = {};

    if (!formValues.area_id) {
      validationErrors.area_id = "Rayon seçin";
    }
    if (!formValues.phone || formValues.phone.trim().length < 7) {
      validationErrors.phone = "Telefon nömrəsini daxil edin";
    }
    if (selectedPackages.length === 0) {
      validationErrors.packages_list = data?.select_package || "Bağlama seçin";
    }
    if (!formValues.payment_type_id) {
      validationErrors.payment_type_id = "Ödəniş növünü seçin";
    }
    if (!formValues.address || formValues.address.trim() === "") {
      validationErrors.address = "Ünvan boş ola bilməz";
    }
    if (!formValues.date) {
      validationErrors.date = "Tarix seçin";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);

    const payload = {
      packages_list: selectedPackages,
      area_id: formValues.area_id,
      address: formValues.address,
      phone: phoneCode + formValues.phone,
      date: formValues.date,
      payment_type_id: formValues.payment_type_id,
      urgent_order: formValues.urgent_order,
      delivery_latitude: addressCoordinates?.lat,
      delivery_longitude: addressCoordinates?.lon,
    };

    const totalAmount =
      (responseCalculate?.delivery_price ?? 0) +
      (responseCalculate?.courier_price ?? 0);

    // Secilmis odenis tipinin nagd olub-olmadigini yoxla
    const selectedPaymentType = payment_type.find(
      (pt) => pt.id.toString() === formValues.payment_type_id
    );
    const isCashPayment =
      selectedPaymentType?.title?.toLowerCase().includes("nağd") ||
      selectedPaymentType?.title?.toLowerCase().includes("nagd");

    // Eger odenis 0 olarsa ve ya nagd olarsa, kart modali gosterme
    if (totalAmount === 0 || isCashPayment) {
      try {
        const response = (await CourierServices.PostCourier(
          payload
        )) as AxiosResponse<ApiResponse>;

        const original = response.data.original;

        if (
          original?.case === "success" &&
          original?.pay === true &&
          original?.content
        ) {
          window.location.href = original.content;
        } else if (isCashPayment) {
          toast.success(
            `${data?.auth_common_cash_selected} ${data?.auth_common_order_received}`
          );
          await refreshOrders();
          setTimeout(() => window.location.reload(), 1000);
        } else if (original?.case === "success") {
          toast.success(original.title || data?.auth_common_order_success);
          await refreshOrders();
          window.location.reload();
        } else {
          toast.error(original?.content || data?.error_occurred);
        }
      } catch (error: any) {
        const backendError = error.original?.content || error?.content;
        if (backendError && typeof backendError === "object") {
          setErrors(backendError);
        } else if (typeof backendError === "string") {
          setPaymentErrorMessage(backendError);
          setPaymentSuccess(false);
          setIsPaymentStatusOpen(true);
        } else if (error?.content?.urgent_order) {
          toast.error(error.content.urgent_order);
        }
      } finally {
        setIsSubmitting(false);
      }
    } else {
      // Odenis tedbiq edilecekse, odenis metodu secimi goster
      setPendingPayload(payload);
      setIsPaymentMethodModalOpen(true);
      setIsSubmitting(false);
    }
  };

  const handleSelectBalancePayment = async () => {
    if (!pendingPayload) return;
    setIsSubmitting(true);
    try {
      const response = (await CourierServices.PostCourier({
        ...pendingPayload,
        payment_provider: "balance",
      })) as AxiosResponse<ApiResponse>;
      const original = response?.data?.original;
      if (original?.case === "success") {
        setIsPaymentMethodModalOpen(false);
        toast.success(original.title || data?.auth_common_order_success);
        await refreshOrders();
        window.location.reload();
      } else {
        setIsPaymentMethodModalOpen(false);
        toast.error(original?.content || data?.error_occurred);
      }
    } catch (error: any) {
      setIsPaymentMethodModalOpen(false);
      const backendError = error.original?.content || error?.content;
      if (backendError && typeof backendError === "object") {
        setErrors(backendError);
      } else {
        setPaymentErrorMessage(typeof backendError === "string" ? backendError : "");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSelectCardPayment = async () => {
    setIsPaymentMethodModalOpen(false);
    try {
      const response = await BankCardsServices.getBankCards();
      const cardsList = response.data?.data || [];

      if (cardsList.length === 0) {
        setIsNoCardsModalOpen(true);
        return;
      }

      setCards(cardsList);
      setIsCardModalOpen(true);
    } catch (error) {
      console.error("Kartlar yuklenirken xeta:", error);
      setIsNoCardsModalOpen(true);
    }
  };

  const handleSelectDirectPayment = async () => {
    setIsPaymentMethodModalOpen(false);
    if (!pendingPayload) return;
    setIsSubmitting(true);
    try {
      const response = (await CourierServices.PostCourier({
        ...pendingPayload,
        payment_provider: "yigim_direct",
      })) as AxiosResponse<ApiResponse>;
      const original = response?.data?.original;
      if (original?.case === "success" && original?.url) {
        window.location.href = original.url;
      } else {
        toast.error(original?.content || data?.error_occurred);
      }
    } catch (error: any) {
      const backendError = error.original?.content || error?.content;
      setPaymentErrorMessage(typeof backendError === "string" ? backendError : "");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSelectPashaPayment = async () => {
    setIsPaymentMethodModalOpen(false);
    if (!pendingPayload) return;

    setIsSubmitting(true);
    try {
      const payloadWithPasha = {
        ...pendingPayload,
        payment_provider: "pasha",
      };

      const response = (await CourierServices.PostCourier(
        payloadWithPasha
      )) as AxiosResponse<ApiResponse>;

      const original = response.data.original;

      if (
        original?.case === "success" &&
        original?.pay === true &&
        original?.content
      ) {
        window.location.href = original.content;
      } else if (original?.case === "success") {
        toast.success(original.title || data?.auth_common_order_success);
        await refreshOrders();
        window.location.reload();
      } else {
        toast.error(original?.content || data?.error_occurred);
      }
    } catch (error: any) {
      const backendError = error.original?.content || error?.content;
      if (backendError && typeof backendError === "object") {
        setErrors(backendError);
      } else if (typeof backendError === "string") {
        setPaymentErrorMessage(backendError);
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      } else if (error?.content?.urgent_order) {
        toast.error(error.content.urgent_order);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCardSelect = async (cardId: number) => {
    if (!pendingPayload) return;

    setIsCardPaymentLoading(true);
    try {
      const payloadWithCard = {
        ...pendingPayload,
        card_id: cardId,
        payment_provider: "card",
      };

      const response = (await CourierServices.PostCourier(
        payloadWithCard
      )) as AxiosResponse<ApiResponse>;

      const original = response.data.original;

      if (original?.case === "success") {
        setPaymentErrorMessage("");
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        await refreshOrders();
      } else if (original?.case === "warning" || original?.case === "error") {
        setPaymentErrorMessage(original?.content || "");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      } else {
        setPaymentErrorMessage("");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } catch (error: any) {
      console.error("Kart odenisi xetasi:", error);
      const backendError = error.original?.content || error?.content;
      setPaymentErrorMessage(typeof backendError === "string" ? backendError : "");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    } finally {
      setIsCardPaymentLoading(false);
      setIsCardModalOpen(false);
    }
  };

  const handlePaymentRedirect = () => {
    setIsPaymentStatusOpen(false);
    if (paymentSuccess) {
      window.location.reload();
    }
  };

  const refreshOrders = async () => {
    setOrderHistoryLoading(true);
    try {
      const res = await CourierServices.getAllOrders();
      setAllOrders(res.data.original.data);
      setPaginationData(res.data.original);
    } catch (error) {
    } finally {
      setOrderHistoryLoading(false);
    }
  };

  useEffect(() => {
    if (formValues.area_id) {
      CourierServices.getPaymentTypesByAreaId(
        parseInt(formValues.area_id),
      ).then((res) => {
        setPaymentType(res.original.payment_types);
      });
    }
  }, [formValues.area_id]);

  const handleOpenModal = () => {
    setModalVisible(true);
  };

  useEffect(() => {
    handlePostOnChange();
  }, [formValues.urgent_order]);

  useEffect(() => {
    if (formValues.area_id) {
      handlePostOnChange();
    }
  }, [formValues.area_id, formValues.urgent_order]);

  const handlePageChange = async (urlOrPage: string | number) => {
    setOrderHistoryLoading(true);
    try {
      let res;
      if (typeof urlOrPage === "string") {
        res = await CourierServices.getAllOrders(urlOrPage);
      } else {
        const url = `/courier/order?page=${urlOrPage}`;
        res = await CourierServices.getAllOrders(url);
      }
      setAllOrders(res.data.original.data);
      setPaginationData(res.data.original);
    } catch (error) {
    } finally {
      setOrderHistoryLoading(false);
    }
  };
  useEffect(() => {}, [paginationData]);
  useEffect(() => {
    if (selectedPackages.length > 0) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.packages_list;
        return newErrors;
      });
    }
  }, [selectedPackages]);

  const handleAddressChange = (newAddress: string) => {
    setFormValues((prev) => ({
      ...prev,
      address: newAddress,
    }));
  };

  const handleCoordinatesChange = (coords: { lat: number; lon: number }) => {
    setAddressCoordinates(coords);
  };

  return (
    <>
      {(serviceDebt.hasDebt || orderDebt.hasDebt) && <ServiceDebtOverlay serviceDebt={serviceDebt} orderDebt={orderDebt} />}
      <TitleUpdater
        title={
          data?.colibri && data?.auth_left_sidebar_courier_order
            ? `${data?.colibri} | ${data?.auth_left_sidebar_courier_order}`
            : "Colibri"
        }
      />
      <form id={styles.purchase}>
        <div className={styles.row}>
          <SelectComponent
            label={data?.auth_courier_area}
            name="area_id"
            options={
              region?.map((item) => ({
                label: item.name,
                value: item.id.toString(),
              })) || []
            }
            placeholder={data?.auth_courier_select}
            value={formValues.area_id}
            onChange={(val: string | number) => {
              setFormValues((prev) => ({ ...prev, area_id: val.toString() }));
              setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors.area_id;
                return newErrors;
              });
            }}
            error={errors.area_id}
          />
          {/* <InputComponent
            label="Mobil nömrə"
            type="tel"
            name="phone"
            placeholder="telefon nömrəsi"
            value={formValues.phone}
            onChange={handleInputChange}
            error={errors.phone}
          /> */}
          <PhoneInputComponent
            label={data?.auth_courier_mobile_number}
            id="phone"
            name="phone"
            placeholder="0000000"
            value={""}
            onChange={(e) =>
              setFormValues((prevValues) => ({
                ...prevValues,
                phone: e.target.value.replace(phoneCode, ""),
              }))
            }
            onCodeChange={(code) => setPhoneCode(code)}
            error={errors.phone}
            combinePrefixWithNumber={true}
          />
        </div>

        <div className={styles.row}>
          <div
            onClick={() => {
              if (formValues.area_id) {
                handleOpenModal();
              }
            }}
            style={{ flex: 1 }}
          >
            <SelectComponent
              label={data?.auth_courier_package}
              name="purchase"
              options={[
                {
                  label:
                    selectedPackages.length > 0
                      ? `${selectedPackages.length} bağlama seçildi`
                      : `${data?.select_package}`,
                  value: "custom",
                },
              ]}
              value="custom"
              onChange={() => {
                setErrors((prevErrors) => {
                  const newErrors = { ...prevErrors };
                  delete newErrors.packages_list;
                  return newErrors;
                });
              }}
              placeholder={data?.auth_courier_select}
              error={errors.packages_list}
              disabled={!formValues.area_id}
              selectedPackagesCount={selectedPackages.length}
            />
          </div>
          <div style={{ flex: 1 }}>
            <SelectComponent
              label={data?.auth_courier_payment_type}
              name="payment_type_id"
              placeholder={data?.auth_courier_select}
              options={
                payment_type?.map((item) => ({
                  label: item.title,
                  value: item.id.toString(),
                })) || []
              }
              value={formValues.payment_type_id.toString()}
              onChange={(val: string | number) => {
                setFormValues((prev) => ({
                  ...prev,
                  payment_type_id: val.toString(),
                }));

                setErrors((prevErrors) => {
                  const newErrors = { ...prevErrors };
                  delete newErrors.payment_type_id;
                  return newErrors;
                });
              }}
              disabled={!formValues.area_id}
              error={errors.payment_type_id}
            />
          </div>
        </div>

        <div className={styles.row}>
          <InputComponent
            label={data?.auth_courier_delivery_address}
            type="text"
            name="address"
            placeholder={data?.auth_courier_address}
            value={formValues.address}
            onChange={handleInputChange}
            error={errors.address}
          />

          <div
            className={styles.dateinputWrapper}
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            {data?.auth_courier_date}
            <div className={styles.dateInputWrapper}>
              <InputComponent
                type="date"
                name="date"
                placeholder={data?.auth_courier_date}
                value={formValues.date}
                min={minDate}
                max={maxDate}
                onChange={(e) => {
                  setFormValues((prev) => ({ ...prev, date: e.target.value }));
                  setErrors((prevErrors) => {
                    const newErrors = { ...prevErrors };
                    delete newErrors.date;
                    return newErrors;
                  });
                }}
                disabled={!minDate || !maxDate}
                className={styles.dateInput}
                ref={inputRef} // Pass ref to the input
              />
              {/* <img
                src={CalendarImg}
                alt="calendar icon"
                className={styles.dateIcon}
                onClick={() => {
                  if (inputRef.current) {
                    inputRef.current.focus(); // Focus on the input to open the calendar
                  }
                }}
                style={{ cursor: "pointer", marginLeft: "10px" }} // Adjust margin if needed
              /> */}
            </div>
            <p className={styles.errorMsg}>{errors.date}</p>
          </div>
        </div>
        {/* <div className={styles.mapContainer}>
          <MapComponent
            address={formValues.address}
            setAddress={handleAddressChange}
            setCoordinates={handleCoordinatesChange}
            initialCoordinates={addressCoordinates}
          />
        </div> */}
        <div className={styles.row}>
          <label className={styles.selectBox}>
            <CustomCheckbox
              icon={checked}
              text={data?.auth_courier_express_delivery}
              color="green"
              checked={formValues.urgent_order}
              onChange={(isChecked) => {
                setFormValues((prev) => ({
                  ...prev,
                  urgent_order: isChecked,
                }));
              }}
              disabled={!formValues.area_id || !selectedPackages.length}
              disabledColor="red" // disabled halda qırmızı rəng
            />
          </label>
        </div>
        <div className={styles.SelectedAllPackages}>
          {orderHistoryLoading ? (
            <div className={styles.loadingWrapper}>
              {/* <Spinner size="large" /> */}
            </div>
          ) : selectedPackageObjects?.length === 0 ? (
            ""
          ) : (
            <table className={styles.order_history_list_select}>
              <thead>
                <tr>
                  <th>{data?.auth_common_tracking_code}</th>
                  <th>{data?.auth_amount}</th>
                  <th>{data?.auth_common_foreign_debt}</th>
                  <th>{data?.auth_common_local_debt}</th>
                </tr>
              </thead>
              <tbody>
                {selectedPackageObjects?.map((order, index) => (
                  <OrderRow key={index} {...order} SelectedPackages={true} />
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className={styles.form_bottom}>
          <div className={styles.purchase_details}>
            <p className={styles.purchase_delivery_cost}>
              {data?.auth_courier_foreign_delivery}
              <span>
                {responseCalculate?.delivery_price
                  ? responseCalculate.delivery_price.toFixed(2)
                  : "0.00"}{" "}
                AZN
              </span>
            </p>

            <p className={styles.purchase_courier_cost}>
              {data?.auth_courier_service}
              <span>
                {(responseCalculate?.courier_price ?? 0).toFixed(2)} AZN
              </span>
            </p>

            <p className={styles.purchase_total_cost}>
              {data?.auth_courier_total_amount}
              <span>
                {(
                  (responseCalculate?.delivery_price ?? 0) +
                  (responseCalculate?.courier_price ?? 0)
                ).toFixed(2)}{" "}
                AZN
              </span>
            </p>
          </div>
          <MainButton
            className={styles.form_submitBtn}
            text={data?.auth_promocode_confirm}
            type="button"
            onClick={handleSubmit}
            disabled={isSubmitting}
          />
        </div>
        <div id={styles.order_list}>
          <div className={styles.pagination_part}>
            <p className={styles.pagination_title}>
              {data?.auth_courier_my_orders}
            </p>
            {(paginationData?.current_page === 1 &&
              paginationData?.next_page_url === null) ||
              (paginationData && (
                <div className={styles.pagination}>
                  <img
                    src={ArrowImage}
                    className={`${styles.pagination_arrow_left} ${
                      !paginationData.prev_page_url ? styles.disabled : ""
                    }`}
                    alt="Prev"
                    onClick={() => {
                      if (paginationData.prev_page_url) {
                        handlePageChange(paginationData.prev_page_url);
                      }
                    }}
                  />

                  {[...Array(paginationData.last_page)].map((_, index) => {
                    const page = index + 1;
                    return (
                      <p
                        key={page}
                        className={`${styles.pagination_count} ${
                          paginationData.current_page === page
                            ? styles.active
                            : ""
                        }`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </p>
                    );
                  })}

                  <img
                    src={ArrowImage}
                    className={`${styles.pagination_arrow_right} ${
                      !paginationData.next_page_url ? styles.disabled : ""
                    }`}
                    alt="Next"
                    onClick={() => {
                      if (paginationData.next_page_url) {
                        handlePageChange(paginationData.next_page_url);
                      }
                    }}
                  />
                </div>
              ))}
          </div>

          {orderHistoryLoading ? (
            <div className={styles.loadingWrapper}>
              <Spinner size="large" />
            </div>
          ) : allOrders?.length === 0 ? (
            <div className={styles.empty}>{data?.auth_courier_no_orders}</div>
          ) : (
            <table className={styles.order_history_list}>
              <thead>
                <tr>
                  <th>{data?.auth_courier_address}</th>
                  <th>{data?.auth_courier_date}</th>
                  <th> {data?.auth_courier_payment_type}</th>
                  <th>{data?.auth_courier_foreign_delivery}</th>
                  <th>{data?.auth_courier_service}</th>
                  <th>{data?.auth_courier_total_amount}</th>
                  <th>{data?.status}</th>
                </tr>
              </thead>
              <tbody>
                {allOrders?.map((order, index) => (
                  <OrderRow key={index} {...order} Courier={true} />
                ))}
              </tbody>
            </table>
          )}

          <div className={styles.courier_card}>
            {allOrders?.map((order, index) => (
              <Card key={index} {...order} Courier={true} />
            ))}
          </div>
        </div>
      </form>
      {isSubmitting && (
        <div className={styles.loadingOverlay}>
          <Spinner size="large" />
        </div>
      )}

      {modalVisible && (
        <PackagesModal
          visible={modalVisible}
          onClose={() => setModalVisible(false)}
          packages={packages || []}
          selectedPackages={selectedPackages}
          setSelectedPackages={setSelectedPackages}
          handlePostOnChange={handlePostOnChange}
          setSelectedPackageObjects={setSelectedPackageObjects}
          showAllPackages={showAllPackages}
          setShowAllPackages={setShowAllPackages}
        />
      )}

      <PaymentMethodModal
        isOpen={isPaymentMethodModalOpen}
        onClose={() => setIsPaymentMethodModalOpen(false)}
        onSelectCard={handleSelectCardPayment}
        // onSelectPasha={handleSelectPashaPayment}
        onSelectBalance={handleSelectBalancePayment}
        onSelectDirectPay={handleSelectDirectPayment}
        amount={`${(
          (responseCalculate?.delivery_price ?? 0) +
          (responseCalculate?.courier_price ?? 0)
        ).toFixed(2)} AZN`}
        translationData={data}
        isLoading={isSubmitting}
      />

      <CardSelectModal
        isOpen={isCardModalOpen}
        onClose={() => setIsCardModalOpen(false)}
        onSelectCard={handleCardSelect}
        cards={cards}
        isLoading={isCardPaymentLoading}
        amount={`${(
          (responseCalculate?.delivery_price ?? 0) +
          (responseCalculate?.courier_price ?? 0)
        ).toFixed(2)} AZN`}
        translationData={data}
      />

      <PaymentStatusModal
        isOpen={isPaymentStatusOpen}
        isSuccess={paymentSuccess}
        onClose={() => setIsPaymentStatusOpen(false)}
        onRedirect={handlePaymentRedirect}
        errorMessage={paymentErrorMessage}
        translationData={data}
      />

      <NoCardsModal
        isOpen={isNoCardsModalOpen}
        onClose={() => setIsNoCardsModalOpen(false)}
        translationData={data}
      />
    </>
  );
};

export default Courier;
